import { render, staticRenderFns } from "./BlogCategoryList.vue?vue&type=template&id=062f500e&"
import script from "./BlogCategoryList.vue?vue&type=script&lang=js&"
export * from "./BlogCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports